'use client';

import { c as _c } from "react/compiler-runtime";
import { type CustomerKycChoice, customerKycOptions, customerReportingCurrency, fundingCountries, isKycCountryField, isKycMoneyField, isKycTaxField } from '@morfi/onramp-sdk';
import type { CustomerKycForm } from '@morfi/onramp-sdk/react';
import { useLocale, useTranslations } from 'next-intl';
import type { ChangeEvent, ReactNode } from 'react';
import { InputField } from '@/components/ui/input-field';
import { SelectField } from '@/components/ui/select-field';
import { useFundingKycLabels } from './use-funding-kyc-labels';
export function FundingKycFields(t0) {
  const $ = _c(13);
  const {
    form
  } = t0;
  const locale = useLocale();
  const t = useTranslations("onramp");
  const labels = useFundingKycLabels();
  let t1;
  if ($[0] !== form.draft.country || $[1] !== form.draft.reportingCountry || $[2] !== form.fields || $[3] !== t) {
    const reportingCurrency = customerReportingCurrency((form.fields.includes("country") ? form.draft.country : form.draft.reportingCountry) ?? "");
    t1 = form.fields.includes("reportingCurrency") && <p className="text-caption text-foreground-secondary">{reportingCurrency ? t("kyc_reporting_amount_help", {
        currency: reportingCurrency
      }) : t("kyc_reporting_help")}</p>;
    $[0] = form.draft.country;
    $[1] = form.draft.reportingCountry;
    $[2] = form.fields;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== form || $[6] !== labels || $[7] !== locale || $[8] !== t) {
    t2 = form.fields.map(field => {
      const choices = customerKycOptions(field);
      const countries = isKycCountryField(field);
      if (countries || choices) {
        return <SelectField key={field} label={labels.fields[field]} value={form.draft[field] ?? ""} onValueChange={value => form.setField(field, value)} disabled={form.busy} placeholder={countries ? t("kyc_choose_country") : t("kyc_choose_option")} items={countries ? fundingCountries(locale).map(_temp) : (choices ?? []).map(value_0 => ({
          value: value_0,
          label: labels.choices[value_0 as CustomerKycChoice]
        }))} />;
      }
      return <InputField key={field} label={labels.fields[field]} type={isKycTaxField(field) ? "password" : field === "dateOfBirth" ? "date" : "text"} inputMode={isKycMoneyField(field) ? "decimal" : field === "transactionFrequencyPerMonth" || field === "ssn" || field === "cpf" ? "numeric" : "text"} value={form.draft[field] ?? ""} disabled={form.busy} autoComplete="off" spellCheck={false} onChange={event => form.setField(field, event.target.value)} />;
    });
    $[5] = form;
    $[6] = labels;
    $[7] = locale;
    $[8] = t;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t1 || $[11] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
function _temp(country) {
  return {
    value: country.code,
    label: country.label
  };
}